import React from 'react';
import { ArrowRight, Plane, MapPin, Calculator } from 'lucide-react';
import './Hero.css';

function Hero() {
  const scrollToDestinations = () => {
    document.getElementById('destinations')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToCalculator = () => {
    document.getElementById('calculator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        <img 
          src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1920&q=80" 
          alt="Couple traveling together watching sunrise" 
          className="hero-image"
        />
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          Entdecke die Welt<br />
          <span className="hero-gradient">on a Budget</span>
        </h1>
        
        <p className="hero-subtitle">
          Aktive Abenteuer, kulturelle Erlebnisse & insider Spartipps für über 20 Destinationen weltweit. 
          Von Tauchen auf den Philippinen bis Trekking in den Alpen.
        </p>
        
        <div className="hero-cta">
          <button className="btn-primary" onClick={scrollToDestinations}>
            Reiseziele entdecken
            <ArrowRight size={20} />
          </button>
          <button className="btn-outline" onClick={scrollToCalculator}>
            <Calculator size={20} />
            Reise kalkulieren
          </button>
        </div>
        
        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-icon">
              <MapPin size={24} />
            </div>
            <div className="stat-text">
              <div className="stat-number">20+</div>
              <div className="stat-label">Destinationen</div>
            </div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-icon">
              <Plane size={24} />
            </div>
            <div className="stat-text">
              <div className="stat-number">50+</div>
              <div className="stat-label">Flughäfen</div>
            </div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-icon">
              <Calculator size={24} />
            </div>
            <div className="stat-text">
              <div className="stat-number">100%</div>
              <div className="stat-label">Budget-Tipps</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
